import { FaPalette } from "react-icons/fa";
import { SiReact, SiNodedotjs } from "react-icons/si";
import { MdSpeed, MdCloudDone } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <SiReact />,
    title: "Full-Stack MERN Development",
    des: "Expert in building scalable web applications using MongoDB, Express.js, React.js, and Node.js. Delivered 15+ production-ready projects with focus on performance, security, and user experience. Proficient in modern React patterns, hooks, context API, and state management.",
  },
  {
    id: 3,
    icon: <MdSpeed />,
    title: "Performance Optimization",
    des: "Reduced application load times by up to 40% through code splitting, lazy loading, and efficient caching strategies. Expert in performance profiling, bundle optimization, and implementing best practices for lightning-fast user experiences.",
  },
  {
    id: 4,
    icon: <MdCloudDone />,
    title: "Cloud Deployment & DevOps",
    des: "Extensive experience deploying applications on AWS, Vercel, and Cloudflare. Implemented CI/CD pipelines, automated testing, and monitoring solutions. Proficient in containerization with Docker and managing production environments.",
  },
  {
    id: 5,
    icon: <SiNodedotjs />,
    title: "API Development & Integration",
    des: "Built secure, scalable RESTful APIs handling 10,000+ daily requests. Expert in JWT authentication, payment gateway integrations (Razorpay, PayPal), real-time features with WebSockets, and third-party API integrations for enhanced functionality.",
  },
  {
    id: 6,
    icon: <FaPalette />,
    title: "Modern UI/UX Implementation",
    des: "Transform designs into pixel-perfect, responsive interfaces using React, Next.js, Material-UI, and Tailwind CSS. Strong eye for detail, accessibility standards (WCAG), and creating intuitive user experiences that drive engagement and conversions.",
  },
];
